import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);
const formats = [
  "DD-MM-YYYY",
  "YYYY-MM-DD",
  "DD/MM/YYYY",
  "YYYY/MM/DD",
  "MM-DD-YYYY",
  "MM/DD/YYYY",
  "DD MMM YYYY",
  "DD MMMM YYYY",
];

// export const formattedDate = (date: any) => {
//   if (!date || date === "null" || date === "undefined") return "";

//   const parsed = dayjs(date, formats, true);
//   return parsed.isValid() ? parsed.format("DD-MM-YYYY") : "";
// };

export const formattedDate = (date: any) => {
  if (!date || date === "null" || date === "undefined") return "-";

  // Handles ISO 8601 strings (e.g. "2026-07-24T06:13:36.741Z") natively
  const isoParsed = dayjs(date);
  if (
    typeof date === "string" &&
    /^\d{4}-\d{2}-\d{2}T/.test(date) &&
    isoParsed.isValid()
  ) {
    return isoParsed.format("DD-MM-YYYY");
  }

  const parsed = dayjs(date, formats, true);
  return parsed.isValid() ? parsed.format("DD-MM-YYYY") : "";
};

export const formattedDateDDMMMMYYYY = (date: any) => {
  if (!date || date === "null" || date === "undefined") return "";

  const parsed = dayjs(date, formats, true);
  return parsed.isValid() ? parsed.format("DD MMM YYYY") : "";
};

// export const formattedDate = (date: any) => {
//   if (!date || date == "" || date == "null" || date == "undefined") return "";
//   return dayjs(date).format("DD-MM-YYYY");
//   //   return dayjs(date).format("DD MMMM YYYY");
// };
